import React from 'react';

function DataTableFilter({ onChangeFilter }) {
  function handleSearch() {
    onChangeFilter('extra_filter', { /* your filter object */ });
  }

  function handleClear() {
    onChangeFilter('extra_filter', {});
  }

  return (
    <div className="p-4 sm:p-5 mb-5">
      {/* Add real input fields (Employee, Date Range, Status, etc.) */}
      <button className="db-btn py-2 text-white bg-primary" onClick={handleSearch}>
        Search
      </button>
      <button className="db-btn py-2 text-white bg-gray-600 ml-2" onClick={handleClear}>
        Clear
      </button>
    </div>
  );
}

export default DataTableFilter;
